/* eslint-disable*/
/* eslint-disable operator-linebreak */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';

import { ReactComponent as BenefitsInfoIcon } from 'src/assets/benefits-info.svg';
import { ReactComponent as BenefitsPersonIcon } from 'src/assets/benefits-person.svg';
import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import {
  CardContentContainer,
  CardContentDate,
  CardContentFee,
  CardContentSubTitle,
  CardContentTitle,
  CardImgContainer,
  CurrentBenefitsCardContainer,
  FallbackImg,
  IconCardSlot,
  IconSlot,
} from './styles';
import { BeneficiariesModal } from '../beneficiaries-modal';
import { BenefitModal } from '../benefit-modal';
import { benefitsForbiddenWords } from '../..';

type CurrentBenefitsCardProps = {
  id: string;
  title: string;
  date?: string;
  benefitName?: string;
  fee: number;
  freePlan?: boolean;
  imgURL?: string;
  basis?: string;
  onBeneficiariesModalIsOpen?: Function;
  onBenefitModalIsOpen?: Function;
  setSelectedBenefit?: any;
  provideBeneficiaries?: boolean;
};

const CurrentBenefitsCard: React.FC<CurrentBenefitsCardProps> = ({
  id,
  title,
  date,
  fee,
  freePlan,
  imgURL,
  onBeneficiariesModalIsOpen,
  onBenefitModalIsOpen,
  setSelectedBenefit,
  provideBeneficiaries,
  benefitName,
  basis,
}) => {
  const { t } = useTranslation();

  const [beneficiariesModalIsOpen, setBeneficiariesIsOpen] = useState<boolean>(false);
  const [benefitModalIsOpen, setBenefitIsOpen] = useState<boolean>(false);

  const handleBeneficiariesModal = () => {
    setBeneficiariesIsOpen(!beneficiariesModalIsOpen);
    if (onBeneficiariesModalIsOpen) onBeneficiariesModalIsOpen();
  };

  const handleBenefitModal = () => {
    setBenefitIsOpen(!benefitModalIsOpen);
    if (onBenefitModalIsOpen) onBenefitModalIsOpen();
  };

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <CurrentBenefitsCardContainer>
      <CardImgContainer>
        <FallbackImg src={imgURL ?? ''} alt="Fallback Image" onError={handleImageError} />
        <IconCardSlot
          style={{ marginLeft: '-40px' }}
          data-testid="benefits-modal-button"
          onClick={() => handleBenefitModal()}
        >
          <IconSlot style={{ marginLeft: '14px' }}>
            <BenefitsInfoIcon />
          </IconSlot>
        </IconCardSlot>
        {provideBeneficiaries ? (
          <IconCardSlot
            style={{ marginLeft: '-80px' }}
            data-testid="beneficiaries-modal-button"
            onClick={() => {
              handleBeneficiariesModal();
              setSelectedBenefit(id);
            }}
          >
            <IconSlot style={{ marginLeft: '11px' }}>
              <BenefitsPersonIcon />
            </IconSlot>
          </IconCardSlot>
        ) : (
          ''
        )}
      </CardImgContainer>
      <CardContentContainer>
        <CardContentTitle>{removeForbiddenWords(title, benefitsForbiddenWords)}</CardContentTitle>
        <CardContentSubTitle>{benefitName}</CardContentSubTitle>
        <CardContentDate>{date ? t('global.form.date') + ` ` + date : ''}</CardContentDate>
        <CardContentFee> {freePlan ? 'Free' : ''}</CardContentFee>
        <CardContentFee> {!basis && !freePlan ? fee.toFixed(2) : ''}</CardContentFee>
        <CardContentFee> {basis === 'FixedAmount' && !freePlan ? monetaryUSDFormat(fee) : ''}</CardContentFee>
        <CardContentFee> {basis === 'PercentOfEarnings' && !freePlan ? `${fee * 100}%` : ''}</CardContentFee>
      </CardContentContainer>
      {beneficiariesModalIsOpen && (
        <BeneficiariesModal
          isOpen={beneficiariesModalIsOpen}
          benefitId={id}
          setBeneficiariesIsOpen={setBeneficiariesIsOpen}
        />
      )}
      {benefitModalIsOpen && (
        <BenefitModal isOpen={benefitModalIsOpen} setBenefitModalIsOpen={setBenefitIsOpen} benefitId={id} />
      )}
    </CurrentBenefitsCardContainer>
  );
};

export default CurrentBenefitsCard;
